import React from 'react';
import { LegalPage } from '../components/legal/LegalPage';

export const PusherPP = () => {
  return (
    <LegalPage
      brand="PUSHER"
      subtitle="Privacy Policy"
      lastUpdated="July 24, 2026"
      intro="PUSHER is a single-player Sokoban-style puzzle game. We are committed to protecting your privacy and collect as little data as possible. By playing the Game, you agree to the practices described below."
      sections={ppSections}
      contactEmail="nokey2723@gmail.com"
    />
  );
};

const ppSections = [
  {
    id: 1,
    header: 'Information We Collect',
    title: 'Data Stored Locally on Your Device',
    description: `PUSHER stores your game progress locally on your device. This includes your unlocked levels, best moves, best times, stars, statistics and app settings (such as sound, haptics, control mode and language). This information stays on your device only and is not transmitted to us. Deleting the Game, or using the "Clear Progress" option inside the Game, removes this data.`,
  },
  {
    id: 2,
    title: 'Information We Do Not Collect',
    description: `PUSHER does not require an account and does not ask for a name, email address, phone number or any other personally identifiable information. We do not knowingly collect contacts, photos, precise location or any sensitive personal data.`,
  },
  {
    id: 3,
    header: 'How Information Is Used',
    title: 'Purpose of Processing',
    description: `Any information handled by the Game is used solely to:`,
    child: [
      {
        id: '3.1',
        description: 'Save and restore your game progress and preferences.',
      },
      {
        id: '3.2',
        description:
          'Provide core gameplay features such as level unlocking, statistics and best scores.',
      },
      {
        id: '3.3',
        description: 'Improve stability and fix problems in the Game.',
      },
    ],
  },
  {
    id: 4,
    header: 'Third-Party Services',
    title: 'Analytics and Advertising',
    description: `The Game may use third-party services (for example, mobile analytics, crash reporting or advertising networks provided by the app store platforms). These services may collect standard technical information such as device model, operating system version, language, an advertising identifier and general usage or diagnostic data. This information is handled under the privacy policies of those providers. If a version of the Game does not include such services, no such data is collected.`,
  },
  {
    id: 5,
    title: 'Platform Providers',
    description: `The Game is distributed through platforms such as the Apple App Store and Google Play. Your use of those platforms is governed by their own terms and privacy policies. We do not control how these platforms process your information.`,
  },
  {
    id: 6,
    header: "Children's Privacy",
    title: 'Users Under 13',
    description: `PUSHER is a family-friendly puzzle game. We do not knowingly collect personal information from children under the age of 13. If you believe a child has provided personal information through any third-party service used by the Game, please contact us so we can take appropriate steps.`,
  },
  {
    id: 7,
    header: 'Your Choices',
    title: 'Managing Your Data',
    description: `You can clear all locally stored progress at any time through the Game's Settings ("Clear Progress"), or by uninstalling the Game. You can also limit ad tracking or reset your advertising identifier through your device's system settings.`,
  },
  {
    id: 8,
    header: 'Data Security',
    title: 'Security',
    description: `Game data is stored locally on your device using standard mobile storage. While we take reasonable measures to protect information, no method of electronic storage is completely secure, and we cannot guarantee absolute security.`,
  },
  {
    id: 9,
    header: 'Changes to This Policy',
    title: 'Updates',
    description: `We may update this Privacy Policy from time to time. Changes will be posted on this page with an updated "Last updated" date. You are advised to review this Privacy Policy periodically. Changes are effective when posted on this page.`,
  },
];
